const supportedSports = new Set(["all", "football", "basketball", "soccer", "baseball", "hockey"]);

// Accept only the one local bridge route and its two expected parameters.
// In particular, never treat a caller-supplied URL as a navigation destination.
export function parseSportsHandoffUrl(value) {
  if (typeof value !== "string" || !value.startsWith("/sso/vyralsports?") || value.includes("#")) {
    return null;
  }

  const query = value.slice("/sso/vyralsports?".length);
  if (query.split("&").length !== 2) return null;
  const params = new URLSearchParams(query);
  if (Array.from(params.keys()).length !== 2 ||
      params.getAll("state").length !== 1 ||
      params.getAll("sport").length !== 1) {
    return null;
  }

  const state = params.get("state");
  const sport = params.get("sport");
  if (!/^[A-Za-z0-9_-]{43}$/.test(state) || !supportedSports.has(sport)) {
    return null;
  }

  return {
    state,
    sport,
    path: `/sso/vyralsports?${new URLSearchParams({ state, sport })}`,
  };
}